import Head from "next/head";
import StartHumming from "pages/components/StartHumming";
import React, { useRef } from "react";
import { ExtendedNextPage } from "types/pages";
import ReactToPrint from "react-to-print";

import Content from "components/Content";
import Label from "components/Label";
import Button from "components/Button";
import HummingNav from "pages/components/HummingNav";
import HummingFooter from "pages/components/HummingFooter";
import styles from "./styles.module.scss";
import { privacy } from "./constants";

const Privacy: ExtendedNextPage = () => {
  const ref = useRef<HTMLDivElement | null>(null);

  return (
    <div ref={ref} className={styles.container}>
      <Head>
        <title>Privacy Policy | Humming Homes</title>
        <meta name="description" content="Privacy & Terms for Humming Homes" />
        <link rel="icon" href="/favicon.ico" />
        <link rel="canonical" href="https://humminghomes.com/privacy" />
      </Head>
      <Content contentClassName={styles.terms}>
        <Label className={styles.title} variant="h1-centered" color="primary">
          Privacy Policy
        </Label>
        {ref.current && (
          <ReactToPrint
            content={() => ref.current}
            trigger={() => (
              <Button
                className={styles.print}
                variant="text"
                onClick={() => {}}
              >
                Print privacy policy
              </Button>
            )}
          />
        )}
        <Label color="primary" useMarkdown>
          {privacy}
        </Label>
      </Content>
      <StartHumming fillColor="primary" />
    </div>
  );
};

Privacy.getLayout = (page) => {
  return (
    <div>
      <HummingNav />
      {page}
      <HummingFooter />
    </div>
  );
};

export default Privacy;
